import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getHydraulicStructureTypeData(context) {
      const response = await Vue.axios.get(`${URL_API}hydraulicstructuretype`);
      let data = response["data"];
      context.commit("updateHydraulicStructureTypeData", data);
    },
    async createHydraulicStructureTypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}hydraulicstructuretype/store`, body, config);
      context.dispatch("getHydraulicStructureTypeData");
    },
    async pushHydraulicStructureTypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}hydraulicstructuretype/update`, body, config);
      context.dispatch("getHydraulicStructureTypeData");
    },
    async destroyHydraulicStructureTypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}hydraulicstructuretype/destroy`, body, config);
      context.dispatch("getHydraulicStructureTypeData");
    }
  },
  mutations: {
    updateHydraulicStructureTypeData(state, hydraulicStructureTypeData) {
      state.hydraulicStructureTypeData = hydraulicStructureTypeData;
    }
  },
  state: {
    hydraulicStructureTypeData: []
  },
  getters: {
    allHydraulicStructureTypeData(state) {
      return state.hydraulicStructureTypeData;
    }
  }
};
